import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { PackageCheck } from "lucide-react";
import { useObrasFinalizadasSinDocs } from "@/hooks/useObrasFinalizadasSinDocs";

interface Props {
  onOpenObra?: (obraId: string) => void;
}

export function ObrasFinalizadasSinDocsCard({ onOpenObra }: Props) {
  const { obras, loading } = useObrasFinalizadasSinDocs();

  if (loading || obras.length === 0) return null;

  return (
    <Card className="border-warning/40 bg-warning/5">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base">
          <PackageCheck className="h-5 w-5 text-warning" />
          Obras finalizadas sin documentación de entrega
          <Badge variant="secondary">{obras.length}</Badge>
        </CardTitle>
        <CardDescription>
          Sube fotos finales, certificados y checklists para cerrar la entrega de cada obra.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-2">
        {obras.slice(0, 5).map((o) => (
          <div key={o.id} className="flex items-center justify-between gap-2 p-2 rounded-md border bg-background">
            <div className="min-w-0">
              <p className="text-sm font-medium truncate">{o.nombre}</p>
              <p className="text-xs text-muted-foreground truncate">
                {o.cliente_nombre ?? "Sin cliente"}
                {o.fecha_fin_real ? ` · finalizada el ${o.fecha_fin_real}` : ""}
                {o.entrega_pospuesta ? " · pospuesta" : ""}
              </p>
            </div>
            {onOpenObra && (
              <Button size="sm" variant="outline" onClick={() => onOpenObra(o.id)}>
                Documentar
              </Button>
            )}
          </div>
        ))}
        {obras.length > 5 && (
          <p className="text-xs text-muted-foreground text-center pt-1">
            Y {obras.length - 5} obra(s) más pendientes.
          </p>
        )}
      </CardContent>
    </Card>
  );
}
